import {
  removeProgress,
  selectUserProgresses,
  setProgress,
} from "Redux/appSlice";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import Button from "../Atoms/Button";
import ExitButton from "../Atoms/ExitButton";
import useConfirmation from "hooks/useConfirmation";
import ConfirmationModal from "Components/Atoms/ConfirmationModal";
import { useState } from "react";

/**
   @function Progress
   show user progress 
   @param progresses {array} - progresses of user
*/
export default function Progress() {
  const userProgresses = useAppSelector(selectUserProgresses);
  const dispatch = useAppDispatch();
  const [progressToLoad, setProgressToLoad] = useState<string | null>(null);

  const [
    isConfirmProgressLoad,
    onLoadProgress,
    onConfirmLoadProgress,
    onCancelLoadProgress,
  ] = useConfirmation({
    onConfirm: () => {
      if (progressToLoad) dispatch(setProgress(progressToLoad));
    },
  });

  const progresses = userProgresses?.map(({ user_progress_id, name, data }) => {
    return (
      <div
        key={user_progress_id}
        className="align-center m-auto mb-2 flex overflow-y-auto"
      >
        <Button
          label={name}
          onClick={() => {
            setProgressToLoad(data);
            onLoadProgress();
          }}
        />
        <div className="m-auto ml-2">
          <ExitButton
            onClick={() =>
              dispatch(
                removeProgress({
                  progressId: user_progress_id,
                })
              )
            }
          />
        </div>
      </div>
    );
  });

  return (
    <>
      <ConfirmationModal
        isOpen={isConfirmProgressLoad}
        content="This action will reset the current progress. Do you want to continue? (If needed, press cancel and save your current progress before proceeding)"
        onContinue={onConfirmLoadProgress}
        onCancel={onCancelLoadProgress}
      />
      <div className="flex flex-col align-middle">
        {progresses && progresses.length > 0 ? (
          progresses
        ) : (
          <div className="m-auto">No Saved Progress</div>
        )}
      </div>
    </>
  );
}
